import * as tooltip from "../components/tooltip";

$(document).ready(function (e) {
  if ($(document).find(".online-form-manager").length > 0) {
    /* ==================================================== HELP MESSAGES === */

    $(".help.online-form-icon").on("click tap", function (e) {
      tooltip.Create($(this).siblings(".help-content").html());
    });
  }
});
